












import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuItemModel } from '@/models/MenuItemModel';

@Component({})
export default class SubMenuItem extends Vue {
  @Prop() private item!: MenuItemModel;

  get price(): string {
    return this.item.sizes.sort((a, b) => Number(a.price) - Number(b.price))[0].price;
  }
}
